<span>{{ minutes }}:{{ seconds | number: '2.0' }}</span>
